import { connect } from "react-redux";
import ForgotOrderNo from "../components/ForgotOrderNo";
import * as actions from "../../../_actions/search";
import * as actions_misc from "../../../_actions/misc";

const mapStateToProps = ({ Search, OrdersSummaryEmail, Misc }) => ({
    search_message: Search.message.value,
    loading: OrdersSummaryEmail.fetching.loading,
    language: Misc.language.language,
    store: Misc.store.store,
    language_list: Misc.language.language_list,
    store_list: Misc.store.store_list,
    language_list_loading: Misc.language.fetching.loading,
    store_list_loading: Misc.store.fetching.loading,
    err: OrdersSummaryEmail.fetching.err
});

const mapDispatchToProps = dispatch => ({
    sendOrdersSummaryEmail: (email, store) => {
        dispatch(actions.sendOrdersSummaryEmail(email, store));
    },
    updateSearchMessage: message => {
        dispatch(actions.updateSearchMessage(message));
    },
    resetSearchMessage: () => {
        dispatch(actions.resetSearchMessage());
    },
    setLanguage: language => {
        dispatch(actions_misc.setLanguage(language));
    },
    setStore: store => {
        dispatch(actions_misc.setStore(store));
    },
    resetLanguage: () => {
        dispatch(actions_misc.resetLanguage());
    },
    resetStore: () => {
        dispatch(actions_misc.resetStore());
    },
    getLanguages() {
        dispatch(actions_misc.getLanguages());
    },
    getStores() {
        dispatch(actions_misc.getStores());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotOrderNo);



// WEBPACK FOOTER //
// ./src/views/Search/containers/ForgotOrderNo.js